import React from 'react';
import  {createRoot, hydrateRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HelmetProvider} from "react-helmet-async";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const rootElement = document.getElementById('root') as HTMLElement
const element = (
  <React.StrictMode>
      <HelmetProvider>
              <App />
      </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
hydrateRoot(rootElement, element)
} else {
    const root = createRoot(rootElement)
    root.render(element)
}
reportWebVitals();
